// extracted by mini-css-extract-plugin
export var centerText = "_6b-8";
export var container = "_6b-0";
export var doughnutContainer = "_6b-7";
export var legend = "_6b-a";
export var legendItemColorDisplay = "_6b-b";
export var legendItemLabel = "_6b-d";
export var legendItemValue = "_6b-c";
export var lg = "_6b-5";
export var maxWidth = "_6b-9";
export var md = "_6b-4";
export var responsive = "_6b-6";
export var sm = "_6b-3";
export var xs = "_6b-2";
export var xxs = "_6b-1";